import { render, staticRenderFns } from "./AlternativeContractTableRow.vue?vue&type=template&id=1ca2d950&"
import script from "./AlternativeContractTableRow.vue?vue&type=script&lang=js&"
export * from "./AlternativeContractTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports